import styled from 'styled-components';
import {Button} from 'antd';

const StyledInvoiceTypeSelectorOutlineButton = styled(Button)`
  border-color: ${props => props.theme.colors.primary_5};
  color: ${props => props.theme.colors.primary_5};
  
  &:not(:disabled):not(.ant-btn-disabled):hover {
    border-color: ${props => props.theme.colors.primary_6};
    color: ${props => props.theme.colors.primary_6};
  }

  &:not(:disabled):not(.ant-btn-disabled):active {
    border-color: ${props => props.theme.colors.primary_7};
    color: ${props => props.theme.colors.primary_7};
  }
`;

export {
  StyledInvoiceTypeSelectorOutlineButton
};
